import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request Interceptor: Attach JWT Token & Tenant Context
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('hs_jwt_token');
    const tenantId = localStorage.getItem('hs_tenant_id') || 'tenant_default';

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers['x-tenant-id'] = tenantId;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Central Error Logging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[AUTH] Unauthorized access. Token may be expired.');
    }
    return Promise.reject(error);
  }
);

export default api;
